const BUCKET_URL =
  "https://storage.googleapis.com/checkit-ac32f.firebasestorage.app";

export async function fetchStoragePath(path) {
  const response = await fetch(`${BUCKET_URL}${path}`);

  if (response.status === 404) {
    return null;
  }

  return await response.json();
}
